(function () {
  const params = new URLSearchParams(window.location.search);
  const gclid = params.get("gclid")
  const fbclid = params.get("fbclid");
  const fbp = getCookie("_fbp");

  // Build fbc from fbclid if present
  const fbc = fbclid
    ? `fb.1.${Date.now()}.${fbclid}`
    : getCookie("_fbc");

  const attributes = {};
    if (gclid) attributes._gclid = gclid;
    if (fbc)   attributes._fbc   = fbc;
    if (fbp)   attributes._fbp   = fbp;
    attributes._ua = navigator.userAgent;

  if (gclid || fbc || fbp) {
        freshpaint.ready(function () {
            const fpId = freshpaint.get_distinct_id();
            if (fpId) attributes._fp_distinct_id = fpId;
 
            fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ attributes }),
            }).then(function (response) {
                if (!response.ok) {
                    console.warn("[tracking] cart/update.js failed:", response.status);
                }
            }).catch(function (err) {
                console.warn("[tracking] cart/update.js error:", err);
            });
        });
    }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }
})();